// extracted by mini-css-extract-plugin
module.exports = {"header":"AuthHeader_header__tDX4t","logo":"AuthHeader_logo__5Q0c8","close-icon":"AuthHeader_close-icon__X_qFp"};